import { fbt } from 'fbtee'
import { blockUserConfirmTitle, blockConfirmLabel } from '../../lib/commonStrings'
import { useBlockedUsers } from '../../contexts/BlockedUsersContext'
import { ReportDialog } from '../../components/ReportDialog'
import { ConfirmDialog } from '../../components/ConfirmDialog'

/** Report + block-confirm dialogs opened from the ⋯ menu on someone's profile. */
export function ModerationDialogs({
  userId,
  reportOpen,
  onReportOpenChange,
  blockOpen,
  onBlockOpenChange,
}: {
  userId: string
  reportOpen: boolean
  onReportOpenChange: (open: boolean) => void
  blockOpen: boolean
  onBlockOpenChange: (open: boolean) => void
}) {
  const { blockUser } = useBlockedUsers()
  return (
    <>
      <ReportDialog
        open={reportOpen}
        onOpenChange={onReportOpenChange}
        contentType="user"
        reportedUserId={userId}
      />
      <ConfirmDialog
        open={blockOpen}
        onOpenChange={onBlockOpenChange}
        onConfirm={async () => {
          onBlockOpenChange(false)
          await blockUser(userId)
        }}
        title={blockUserConfirmTitle()}
        description={fbt(
          "You won't see their posts anymore. You can unblock them later.",
          'Confirm dialog body for blocking a user from their profile',
        )}
        confirmLabel={blockConfirmLabel()}
        destructive
      />
    </>
  )
}
